/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
let domain = ''
export const getDomain = () => {
  return domain
}
export const setDomain = ($domain) => {
  domain = $domain
}
export const request = (method, url, body, queryParameters, form, config) => {
  method = method.toLowerCase()
  let keys = Object.keys(queryParameters)
  let queryUrl = url
  if (keys.length > 0) {
    queryUrl = url + '?' + qs.stringify(queryParameters)
  }
  if (body) {
    if (method === 'delete') {
      return axios[method](queryUrl, {
        data: body
      }, config)
    }
    return axios[method](queryUrl, body, config)
  } else if (method === 'get') {
    return axios[method](queryUrl, {
      params: form
    }, config)
  } else {
    return axios[method](queryUrl, qs.stringify(form), config)
  }
}
/*==========================================================
 *                    
 ==========================================================*/
/**
 * 
 * request: Acquisition_ReferalCodes
 * url: Acquisition_ReferalCodesURL
 * method: Acquisition_ReferalCodes_TYPE
 * raw_url: Acquisition_ReferalCodes_RAW_URL
 * @param page - 
 * @param pageSize - 
 * @param sortBy - 
 * @param text - 
 * @param code - 
 */
export const Acquisition_ReferalCodes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/acquisition'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['text'] !== undefined) {
    queryParameters['Text'] = parameters['text']
  }
  if (parameters['code'] !== undefined) {
    queryParameters['Code'] = parameters['code']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Acquisition_ReferalCodes_RAW_URL = function() {
  return '/api/management/acquisition'
}
export const Acquisition_ReferalCodes_TYPE = function() {
  return 'get'
}
export const Acquisition_ReferalCodesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/acquisition'
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['text'] !== undefined) {
    queryParameters['Text'] = parameters['text']
  }
  if (parameters['code'] !== undefined) {
    queryParameters['Code'] = parameters['code']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Acquisition_Issue
 * url: Acquisition_IssueURL
 * method: Acquisition_Issue_TYPE
 * raw_url: Acquisition_Issue_RAW_URL
 * @param cmd - 
 */
export const Acquisition_Issue = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/acquisition/issue'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Acquisition_Issue_RAW_URL = function() {
  return '/api/management/acquisition/issue'
}
export const Acquisition_Issue_TYPE = function() {
  return 'post'
}
export const Acquisition_IssueURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/acquisition/issue'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Acquisition_Disable
 * url: Acquisition_DisableURL
 * method: Acquisition_Disable_TYPE
 * raw_url: Acquisition_Disable_RAW_URL
 * @param cmd - 
 */
export const Acquisition_Disable = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/acquisition/disable'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Acquisition_Disable_RAW_URL = function() {
  return '/api/management/acquisition/disable'
}
export const Acquisition_Disable_TYPE = function() {
  return 'post'
}
export const Acquisition_DisableURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/acquisition/disable'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Auth_Login
 * url: Auth_LoginURL
 * method: Auth_Login_TYPE
 * raw_url: Auth_Login_RAW_URL
 * @param cmd - 
 */
export const Auth_Login = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/auth/login'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Auth_Login_RAW_URL = function() {
  return '/api/management/auth/login'
}
export const Auth_Login_TYPE = function() {
  return 'post'
}
export const Auth_LoginURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/auth/login'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Auth_RegisterBackOfficeUser
 * url: Auth_RegisterBackOfficeUserURL
 * method: Auth_RegisterBackOfficeUser_TYPE
 * raw_url: Auth_RegisterBackOfficeUser_RAW_URL
 * @param cmd - 
 */
export const Auth_RegisterBackOfficeUser = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/auth/register'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Auth_RegisterBackOfficeUser_RAW_URL = function() {
  return '/api/management/auth/register'
}
export const Auth_RegisterBackOfficeUser_TYPE = function() {
  return 'post'
}
export const Auth_RegisterBackOfficeUserURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/auth/register'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Auth_Refresh
 * url: Auth_RefreshURL
 * method: Auth_Refresh_TYPE
 * raw_url: Auth_Refresh_RAW_URL
 * @param cmd - 
 */
export const Auth_Refresh = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/auth/connect/refresh'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Auth_Refresh_RAW_URL = function() {
  return '/api/management/auth/connect/refresh'
}
export const Auth_Refresh_TYPE = function() {
  return 'post'
}
export const Auth_RefreshURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/auth/connect/refresh'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Cache_Fulltext
 * url: Cache_FulltextURL
 * method: Cache_Fulltext_TYPE
 * raw_url: Cache_Fulltext_RAW_URL
 */
export const Cache_Fulltext = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/cache/ft'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const Cache_Fulltext_RAW_URL = function() {
  return '/api/management/cache/ft'
}
export const Cache_Fulltext_TYPE = function() {
  return 'delete'
}
export const Cache_FulltextURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/cache/ft'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Cache_Hotelindex
 * url: Cache_HotelindexURL
 * method: Cache_Hotelindex_TYPE
 * raw_url: Cache_Hotelindex_RAW_URL
 */
export const Cache_Hotelindex = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/cache/hi'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const Cache_Hotelindex_RAW_URL = function() {
  return '/api/management/cache/hi'
}
export const Cache_Hotelindex_TYPE = function() {
  return 'delete'
}
export const Cache_HotelindexURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/cache/hi'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Cache_Key
 * url: Cache_KeyURL
 * method: Cache_Key_TYPE
 * raw_url: Cache_Key_RAW_URL
 * @param key - 
 */
export const Cache_Key = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/cache/key/{key}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters['key'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: key'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const Cache_Key_RAW_URL = function() {
  return '/api/management/cache/key/{key}'
}
export const Cache_Key_TYPE = function() {
  return 'delete'
}
export const Cache_KeyURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/cache/key/{key}'
  path = path.replace('{key}', `${parameters['key']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Cache_Clear
 * url: Cache_ClearURL
 * method: Cache_Clear_TYPE
 * raw_url: Cache_Clear_RAW_URL
 */
export const Cache_Clear = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/cache/all'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const Cache_Clear_RAW_URL = function() {
  return '/api/management/cache/all'
}
export const Cache_Clear_TYPE = function() {
  return 'delete'
}
export const Cache_ClearURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/cache/all'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: GiftCard_List
 * url: GiftCard_ListURL
 * method: GiftCard_List_TYPE
 * raw_url: GiftCard_List_RAW_URL
 * @param page - 
 * @param pageSize - 
 * @param sortBy - 
 * @param text - 
 */
export const GiftCard_List = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/giftcard'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['text'] !== undefined) {
    queryParameters['Text'] = parameters['text']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const GiftCard_List_RAW_URL = function() {
  return '/api/management/giftcard'
}
export const GiftCard_List_TYPE = function() {
  return 'get'
}
export const GiftCard_ListURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/giftcard'
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['text'] !== undefined) {
    queryParameters['Text'] = parameters['text']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: GiftCard_Issue
 * url: GiftCard_IssueURL
 * method: GiftCard_Issue_TYPE
 * raw_url: GiftCard_Issue_RAW_URL
 * @param cmd - 
 */
export const GiftCard_Issue = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/giftcard/issue'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const GiftCard_Issue_RAW_URL = function() {
  return '/api/management/giftcard/issue'
}
export const GiftCard_Issue_TYPE = function() {
  return 'post'
}
export const GiftCard_IssueURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/giftcard/issue'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: GiftCard_Disable
 * url: GiftCard_DisableURL
 * method: GiftCard_Disable_TYPE
 * raw_url: GiftCard_Disable_RAW_URL
 * @param cmd - 
 */
export const GiftCard_Disable = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/giftcard/disable'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const GiftCard_Disable_RAW_URL = function() {
  return '/api/management/giftcard/disable'
}
export const GiftCard_Disable_TYPE = function() {
  return 'post'
}
export const GiftCard_DisableURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/giftcard/disable'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Metric_Get
 * url: Metric_GetURL
 * method: Metric_Get_TYPE
 * raw_url: Metric_Get_RAW_URL
 */
export const Metric_Get = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/metric/default'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Metric_Get_RAW_URL = function() {
  return '/api/management/metric/default'
}
export const Metric_Get_TYPE = function() {
  return 'get'
}
export const Metric_GetURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/metric/default'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_ImportOffer
 * url: OfferTemplate_ImportOfferURL
 * method: OfferTemplate_ImportOffer_TYPE
 * raw_url: OfferTemplate_ImportOffer_RAW_URL
 * @param offer - 
 */
export const OfferTemplate_ImportOffer = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/offer'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['offer'] !== undefined) {
    body = parameters['offer']
  }
  if (parameters['offer'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: offer'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_ImportOffer_RAW_URL = function() {
  return '/api/management/offertemplate/offer'
}
export const OfferTemplate_ImportOffer_TYPE = function() {
  return 'post'
}
export const OfferTemplate_ImportOfferURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/offer'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_ImportContact
 * url: OfferTemplate_ImportContactURL
 * method: OfferTemplate_ImportContact_TYPE
 * raw_url: OfferTemplate_ImportContact_RAW_URL
 * @param contact - 
 */
export const OfferTemplate_ImportContact = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/contact'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['contact'] !== undefined) {
    body = parameters['contact']
  }
  if (parameters['contact'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: contact'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_ImportContact_RAW_URL = function() {
  return '/api/management/offertemplate/contact'
}
export const OfferTemplate_ImportContact_TYPE = function() {
  return 'post'
}
export const OfferTemplate_ImportContactURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/contact'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_Disable
 * url: OfferTemplate_DisableURL
 * method: OfferTemplate_Disable_TYPE
 * raw_url: OfferTemplate_Disable_RAW_URL
 * @param id - 
 */
export const OfferTemplate_Disable = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    body = parameters['id']
  }
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_Disable_RAW_URL = function() {
  return '/api/management/offertemplate'
}
export const OfferTemplate_Disable_TYPE = function() {
  return 'put'
}
export const OfferTemplate_DisableURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_Get
 * url: OfferTemplate_GetURL
 * method: OfferTemplate_Get_TYPE
 * raw_url: OfferTemplate_Get_RAW_URL
 * @param sortBy - 
 * @param page - 
 * @param pageSize - 
 * @param online - 
 * @param offline - 
 * @param fulltextSearch - 
 */
export const OfferTemplate_Get = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['online'] !== undefined) {
    queryParameters['Online'] = parameters['online']
  }
  if (parameters['offline'] !== undefined) {
    queryParameters['Offline'] = parameters['offline']
  }
  if (parameters['fulltextSearch'] !== undefined) {
    queryParameters['FulltextSearch'] = parameters['fulltextSearch']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_Get_RAW_URL = function() {
  return '/api/management/offertemplate'
}
export const OfferTemplate_Get_TYPE = function() {
  return 'get'
}
export const OfferTemplate_GetURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate'
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['online'] !== undefined) {
    queryParameters['Online'] = parameters['online']
  }
  if (parameters['offline'] !== undefined) {
    queryParameters['Offline'] = parameters['offline']
  }
  if (parameters['fulltextSearch'] !== undefined) {
    queryParameters['FulltextSearch'] = parameters['fulltextSearch']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_AddTravelDealPromotion
 * url: OfferTemplate_AddTravelDealPromotionURL
 * method: OfferTemplate_AddTravelDealPromotion_TYPE
 * raw_url: OfferTemplate_AddTravelDealPromotion_RAW_URL
 * @param promotion - 
 */
export const OfferTemplate_AddTravelDealPromotion = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/promotion/traveldeal'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['promotion'] !== undefined) {
    body = parameters['promotion']
  }
  if (parameters['promotion'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: promotion'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_AddTravelDealPromotion_RAW_URL = function() {
  return '/api/management/offertemplate/promotion/traveldeal'
}
export const OfferTemplate_AddTravelDealPromotion_TYPE = function() {
  return 'post'
}
export const OfferTemplate_AddTravelDealPromotionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/promotion/traveldeal'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_AddTravelDealPromotionBySstIds
 * url: OfferTemplate_AddTravelDealPromotionBySstIdsURL
 * method: OfferTemplate_AddTravelDealPromotionBySstIds_TYPE
 * raw_url: OfferTemplate_AddTravelDealPromotionBySstIds_RAW_URL
 * @param promotion - 
 */
export const OfferTemplate_AddTravelDealPromotionBySstIds = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/promotion/traveldeal-by-sst'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['promotion'] !== undefined) {
    body = parameters['promotion']
  }
  if (parameters['promotion'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: promotion'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_AddTravelDealPromotionBySstIds_RAW_URL = function() {
  return '/api/management/offertemplate/promotion/traveldeal-by-sst'
}
export const OfferTemplate_AddTravelDealPromotionBySstIds_TYPE = function() {
  return 'post'
}
export const OfferTemplate_AddTravelDealPromotionBySstIdsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/promotion/traveldeal-by-sst'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_AddCustomReducingPromotionBySstIds
 * url: OfferTemplate_AddCustomReducingPromotionBySstIdsURL
 * method: OfferTemplate_AddCustomReducingPromotionBySstIds_TYPE
 * raw_url: OfferTemplate_AddCustomReducingPromotionBySstIds_RAW_URL
 * @param promotion - 
 */
export const OfferTemplate_AddCustomReducingPromotionBySstIds = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/promotion/custom-by-sst'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['promotion'] !== undefined) {
    body = parameters['promotion']
  }
  if (parameters['promotion'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: promotion'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_AddCustomReducingPromotionBySstIds_RAW_URL = function() {
  return '/api/management/offertemplate/promotion/custom-by-sst'
}
export const OfferTemplate_AddCustomReducingPromotionBySstIds_TYPE = function() {
  return 'post'
}
export const OfferTemplate_AddCustomReducingPromotionBySstIdsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/promotion/custom-by-sst'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_RemoveTravelDealPromotion
 * url: OfferTemplate_RemoveTravelDealPromotionURL
 * method: OfferTemplate_RemoveTravelDealPromotion_TYPE
 * raw_url: OfferTemplate_RemoveTravelDealPromotion_RAW_URL
 * @param promotion - 
 */
export const OfferTemplate_RemoveTravelDealPromotion = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/promotion'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['promotion'] !== undefined) {
    body = parameters['promotion']
  }
  if (parameters['promotion'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: promotion'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_RemoveTravelDealPromotion_RAW_URL = function() {
  return '/api/management/offertemplate/promotion'
}
export const OfferTemplate_RemoveTravelDealPromotion_TYPE = function() {
  return 'delete'
}
export const OfferTemplate_RemoveTravelDealPromotionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/promotion'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_GetById
 * url: OfferTemplate_GetByIdURL
 * method: OfferTemplate_GetById_TYPE
 * raw_url: OfferTemplate_GetById_RAW_URL
 * @param id - 
 */
export const OfferTemplate_GetById = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/id/{id}'
  let body
  let queryParameters = {}
  let form = {}
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters['id'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: id'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_GetById_RAW_URL = function() {
  return '/api/management/offertemplate/id/{id}'
}
export const OfferTemplate_GetById_TYPE = function() {
  return 'get'
}
export const OfferTemplate_GetByIdURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/id/{id}'
  path = path.replace('{id}', `${parameters['id']}`)
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_GetPromotions
 * url: OfferTemplate_GetPromotionsURL
 * method: OfferTemplate_GetPromotions_TYPE
 * raw_url: OfferTemplate_GetPromotions_RAW_URL
 * @param sortBy - 
 * @param page - 
 * @param pageSize - 
 */
export const OfferTemplate_GetPromotions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/promotions'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_GetPromotions_RAW_URL = function() {
  return '/api/management/offertemplate/promotions'
}
export const OfferTemplate_GetPromotions_TYPE = function() {
  return 'get'
}
export const OfferTemplate_GetPromotionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/promotions'
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_GetKnownPromotions
 * url: OfferTemplate_GetKnownPromotionsURL
 * method: OfferTemplate_GetKnownPromotions_TYPE
 * raw_url: OfferTemplate_GetKnownPromotions_RAW_URL
 */
export const OfferTemplate_GetKnownPromotions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/known-promotions'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_GetKnownPromotions_RAW_URL = function() {
  return '/api/management/offertemplate/known-promotions'
}
export const OfferTemplate_GetKnownPromotions_TYPE = function() {
  return 'get'
}
export const OfferTemplate_GetKnownPromotionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/known-promotions'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_GetKnownThemes
 * url: OfferTemplate_GetKnownThemesURL
 * method: OfferTemplate_GetKnownThemes_TYPE
 * raw_url: OfferTemplate_GetKnownThemes_RAW_URL
 */
export const OfferTemplate_GetKnownThemes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/known-themes'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_GetKnownThemes_RAW_URL = function() {
  return '/api/management/offertemplate/known-themes'
}
export const OfferTemplate_GetKnownThemes_TYPE = function() {
  return 'get'
}
export const OfferTemplate_GetKnownThemesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/known-themes'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OfferTemplate_GetKnownCountries
 * url: OfferTemplate_GetKnownCountriesURL
 * method: OfferTemplate_GetKnownCountries_TYPE
 * raw_url: OfferTemplate_GetKnownCountries_RAW_URL
 */
export const OfferTemplate_GetKnownCountries = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/offertemplate/known-countries'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OfferTemplate_GetKnownCountries_RAW_URL = function() {
  return '/api/management/offertemplate/known-countries'
}
export const OfferTemplate_GetKnownCountries_TYPE = function() {
  return 'get'
}
export const OfferTemplate_GetKnownCountriesURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/offertemplate/known-countries'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OrderManagement_ClosedOrders
 * url: OrderManagement_ClosedOrdersURL
 * method: OrderManagement_ClosedOrders_TYPE
 * raw_url: OrderManagement_ClosedOrders_RAW_URL
 * @param page - 
 * @param pageSize - 
 * @param sortBy - 
 * @param orderDateFrom - 
 * @param orderDateTo - 
 * @param fulltextSearch - 
 */
export const OrderManagement_ClosedOrders = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/ordermanagement/closed'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['orderDateFrom'] !== undefined) {
    queryParameters['OrderDateFrom'] = parameters['orderDateFrom']
  }
  if (parameters['orderDateTo'] !== undefined) {
    queryParameters['OrderDateTo'] = parameters['orderDateTo']
  }
  if (parameters['fulltextSearch'] !== undefined) {
    queryParameters['FulltextSearch'] = parameters['fulltextSearch']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OrderManagement_ClosedOrders_RAW_URL = function() {
  return '/api/management/ordermanagement/closed'
}
export const OrderManagement_ClosedOrders_TYPE = function() {
  return 'get'
}
export const OrderManagement_ClosedOrdersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/ordermanagement/closed'
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['orderDateFrom'] !== undefined) {
    queryParameters['OrderDateFrom'] = parameters['orderDateFrom']
  }
  if (parameters['orderDateTo'] !== undefined) {
    queryParameters['OrderDateTo'] = parameters['orderDateTo']
  }
  if (parameters['fulltextSearch'] !== undefined) {
    queryParameters['FulltextSearch'] = parameters['fulltextSearch']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OrderManagement_CancelledOrders
 * url: OrderManagement_CancelledOrdersURL
 * method: OrderManagement_CancelledOrders_TYPE
 * raw_url: OrderManagement_CancelledOrders_RAW_URL
 * @param page - 
 * @param pageSize - 
 * @param sortBy - 
 * @param cancellationDateFrom - 
 * @param cancellationDateTo - 
 * @param fulltextSearch - 
 */
export const OrderManagement_CancelledOrders = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/ordermanagement/cancelled'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['cancellationDateFrom'] !== undefined) {
    queryParameters['CancellationDateFrom'] = parameters['cancellationDateFrom']
  }
  if (parameters['cancellationDateTo'] !== undefined) {
    queryParameters['CancellationDateTo'] = parameters['cancellationDateTo']
  }
  if (parameters['fulltextSearch'] !== undefined) {
    queryParameters['FulltextSearch'] = parameters['fulltextSearch']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OrderManagement_CancelledOrders_RAW_URL = function() {
  return '/api/management/ordermanagement/cancelled'
}
export const OrderManagement_CancelledOrders_TYPE = function() {
  return 'get'
}
export const OrderManagement_CancelledOrdersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/ordermanagement/cancelled'
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['cancellationDateFrom'] !== undefined) {
    queryParameters['CancellationDateFrom'] = parameters['cancellationDateFrom']
  }
  if (parameters['cancellationDateTo'] !== undefined) {
    queryParameters['CancellationDateTo'] = parameters['cancellationDateTo']
  }
  if (parameters['fulltextSearch'] !== undefined) {
    queryParameters['FulltextSearch'] = parameters['fulltextSearch']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OrderManagement_OrderDetails
 * url: OrderManagement_OrderDetailsURL
 * method: OrderManagement_OrderDetails_TYPE
 * raw_url: OrderManagement_OrderDetails_RAW_URL
 * @param id - 
 */
export const OrderManagement_OrderDetails = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/ordermanagement/details'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['id'] !== undefined) {
    queryParameters['Id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const OrderManagement_OrderDetails_RAW_URL = function() {
  return '/api/management/ordermanagement/details'
}
export const OrderManagement_OrderDetails_TYPE = function() {
  return 'get'
}
export const OrderManagement_OrderDetailsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/ordermanagement/details'
  if (parameters['id'] !== undefined) {
    queryParameters['Id'] = parameters['id']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OrderManagement_CancelOrder
 * url: OrderManagement_CancelOrderURL
 * method: OrderManagement_CancelOrder_TYPE
 * raw_url: OrderManagement_CancelOrder_RAW_URL
 * @param cmd - 
 */
export const OrderManagement_CancelOrder = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/ordermanagement/cancel'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const OrderManagement_CancelOrder_RAW_URL = function() {
  return '/api/management/ordermanagement/cancel'
}
export const OrderManagement_CancelOrder_TYPE = function() {
  return 'put'
}
export const OrderManagement_CancelOrderURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/ordermanagement/cancel'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OrderManagement_CancelVouchers
 * url: OrderManagement_CancelVouchersURL
 * method: OrderManagement_CancelVouchers_TYPE
 * raw_url: OrderManagement_CancelVouchers_RAW_URL
 * @param cmd - 
 */
export const OrderManagement_CancelVouchers = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/ordermanagement/cancel-vouchers'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const OrderManagement_CancelVouchers_RAW_URL = function() {
  return '/api/management/ordermanagement/cancel-vouchers'
}
export const OrderManagement_CancelVouchers_TYPE = function() {
  return 'put'
}
export const OrderManagement_CancelVouchersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/ordermanagement/cancel-vouchers'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OrderManagement_SetOrderPaid
 * url: OrderManagement_SetOrderPaidURL
 * method: OrderManagement_SetOrderPaid_TYPE
 * raw_url: OrderManagement_SetOrderPaid_RAW_URL
 * @param cmd - 
 */
export const OrderManagement_SetOrderPaid = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/ordermanagement/paid'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const OrderManagement_SetOrderPaid_RAW_URL = function() {
  return '/api/management/ordermanagement/paid'
}
export const OrderManagement_SetOrderPaid_TYPE = function() {
  return 'put'
}
export const OrderManagement_SetOrderPaidURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/ordermanagement/paid'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: OrderManagement_SetOrderPartlyPaid
 * url: OrderManagement_SetOrderPartlyPaidURL
 * method: OrderManagement_SetOrderPartlyPaid_TYPE
 * raw_url: OrderManagement_SetOrderPartlyPaid_RAW_URL
 * @param cmd - 
 */
export const OrderManagement_SetOrderPartlyPaid = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/ordermanagement/partly-paid'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const OrderManagement_SetOrderPartlyPaid_RAW_URL = function() {
  return '/api/management/ordermanagement/partly-paid'
}
export const OrderManagement_SetOrderPartlyPaid_TYPE = function() {
  return 'put'
}
export const OrderManagement_SetOrderPartlyPaidURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/ordermanagement/partly-paid'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Reduction_Reductions
 * url: Reduction_ReductionsURL
 * method: Reduction_Reductions_TYPE
 * raw_url: Reduction_Reductions_RAW_URL
 * @param page - 
 * @param pageSize - 
 * @param sortBy - 
 * @param text - 
 * @param code - 
 * @param unique - 
 */
export const Reduction_Reductions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/reduction'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['text'] !== undefined) {
    queryParameters['Text'] = parameters['text']
  }
  if (parameters['code'] !== undefined) {
    queryParameters['Code'] = parameters['code']
  }
  if (parameters['unique'] !== undefined) {
    queryParameters['Unique'] = parameters['unique']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Reduction_Reductions_RAW_URL = function() {
  return '/api/management/reduction'
}
export const Reduction_Reductions_TYPE = function() {
  return 'get'
}
export const Reduction_ReductionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/reduction'
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['text'] !== undefined) {
    queryParameters['Text'] = parameters['text']
  }
  if (parameters['code'] !== undefined) {
    queryParameters['Code'] = parameters['code']
  }
  if (parameters['unique'] !== undefined) {
    queryParameters['Unique'] = parameters['unique']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Reduction_DeleteReduction
 * url: Reduction_DeleteReductionURL
 * method: Reduction_DeleteReduction_TYPE
 * raw_url: Reduction_DeleteReduction_RAW_URL
 * @param cmd - 
 */
export const Reduction_DeleteReduction = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/reduction'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('delete', domain + path, body, queryParameters, form, config)
}
export const Reduction_DeleteReduction_RAW_URL = function() {
  return '/api/management/reduction'
}
export const Reduction_DeleteReduction_TYPE = function() {
  return 'delete'
}
export const Reduction_DeleteReductionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/reduction'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Reduction_CreatePercentageReduction
 * url: Reduction_CreatePercentageReductionURL
 * method: Reduction_CreatePercentageReduction_TYPE
 * raw_url: Reduction_CreatePercentageReduction_RAW_URL
 * @param cmd - 
 */
export const Reduction_CreatePercentageReduction = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/reduction/percentage'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Reduction_CreatePercentageReduction_RAW_URL = function() {
  return '/api/management/reduction/percentage'
}
export const Reduction_CreatePercentageReduction_TYPE = function() {
  return 'post'
}
export const Reduction_CreatePercentageReductionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/reduction/percentage'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Reduction_CreateFixedReduction
 * url: Reduction_CreateFixedReductionURL
 * method: Reduction_CreateFixedReduction_TYPE
 * raw_url: Reduction_CreateFixedReduction_RAW_URL
 * @param cmd - 
 */
export const Reduction_CreateFixedReduction = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/reduction/fixed-amount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Reduction_CreateFixedReduction_RAW_URL = function() {
  return '/api/management/reduction/fixed-amount'
}
export const Reduction_CreateFixedReduction_TYPE = function() {
  return 'post'
}
export const Reduction_CreateFixedReductionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/reduction/fixed-amount'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Reduction_CreateUniquePercentageReductions
 * url: Reduction_CreateUniquePercentageReductionsURL
 * method: Reduction_CreateUniquePercentageReductions_TYPE
 * raw_url: Reduction_CreateUniquePercentageReductions_RAW_URL
 * @param cmd - 
 */
export const Reduction_CreateUniquePercentageReductions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/reduction/unique/percentage'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Reduction_CreateUniquePercentageReductions_RAW_URL = function() {
  return '/api/management/reduction/unique/percentage'
}
export const Reduction_CreateUniquePercentageReductions_TYPE = function() {
  return 'post'
}
export const Reduction_CreateUniquePercentageReductionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/reduction/unique/percentage'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Reduction_CreateUniqueFixedReductions
 * url: Reduction_CreateUniqueFixedReductionsURL
 * method: Reduction_CreateUniqueFixedReductions_TYPE
 * raw_url: Reduction_CreateUniqueFixedReductions_RAW_URL
 * @param cmd - 
 */
export const Reduction_CreateUniqueFixedReductions = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/reduction/unique/fixed-amount'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Reduction_CreateUniqueFixedReductions_RAW_URL = function() {
  return '/api/management/reduction/unique/fixed-amount'
}
export const Reduction_CreateUniqueFixedReductions_TYPE = function() {
  return 'post'
}
export const Reduction_CreateUniqueFixedReductionsURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/reduction/unique/fixed-amount'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Statistics_Get
 * url: Statistics_GetURL
 * method: Statistics_Get_TYPE
 * raw_url: Statistics_Get_RAW_URL
 */
export const Statistics_Get = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/statistics/available'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Statistics_Get_RAW_URL = function() {
  return '/api/management/statistics/available'
}
export const Statistics_Get_TYPE = function() {
  return 'get'
}
export const Statistics_GetURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/statistics/available'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Statistics_UsedPrmotionCodeStatisticsQuery
 * url: Statistics_UsedPrmotionCodeStatisticsQueryURL
 * method: Statistics_UsedPrmotionCodeStatisticsQuery_TYPE
 * raw_url: Statistics_UsedPrmotionCodeStatisticsQuery_RAW_URL
 * @param from - 
 * @param to - 
 * @param page - 
 * @param pageSize - 
 * @param sortBy - 
 */
export const Statistics_UsedPrmotionCodeStatisticsQuery = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/statistics/promotion-overview'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['from'] !== undefined) {
    queryParameters['From'] = parameters['from']
  }
  if (parameters['to'] !== undefined) {
    queryParameters['To'] = parameters['to']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Statistics_UsedPrmotionCodeStatisticsQuery_RAW_URL = function() {
  return '/api/management/statistics/promotion-overview'
}
export const Statistics_UsedPrmotionCodeStatisticsQuery_TYPE = function() {
  return 'get'
}
export const Statistics_UsedPrmotionCodeStatisticsQueryURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/statistics/promotion-overview'
  if (parameters['from'] !== undefined) {
    queryParameters['From'] = parameters['from']
  }
  if (parameters['to'] !== undefined) {
    queryParameters['To'] = parameters['to']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Statistics_OrderSummaryQuery
 * url: Statistics_OrderSummaryQueryURL
 * method: Statistics_OrderSummaryQuery_TYPE
 * raw_url: Statistics_OrderSummaryQuery_RAW_URL
 * @param createdFrom - 
 * @param createdTo - 
 * @param page - 
 * @param pageSize - 
 * @param sortBy - 
 */
export const Statistics_OrderSummaryQuery = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/statistics/order-summary'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['createdFrom'] !== undefined) {
    queryParameters['CreatedFrom'] = parameters['createdFrom']
  }
  if (parameters['createdTo'] !== undefined) {
    queryParameters['CreatedTo'] = parameters['createdTo']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Statistics_OrderSummaryQuery_RAW_URL = function() {
  return '/api/management/statistics/order-summary'
}
export const Statistics_OrderSummaryQuery_TYPE = function() {
  return 'get'
}
export const Statistics_OrderSummaryQueryURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/statistics/order-summary'
  if (parameters['createdFrom'] !== undefined) {
    queryParameters['CreatedFrom'] = parameters['createdFrom']
  }
  if (parameters['createdTo'] !== undefined) {
    queryParameters['CreatedTo'] = parameters['createdTo']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Tasks_RetriggerOrderFulfillment
 * url: Tasks_RetriggerOrderFulfillmentURL
 * method: Tasks_RetriggerOrderFulfillment_TYPE
 * raw_url: Tasks_RetriggerOrderFulfillment_RAW_URL
 * @param req - 
 */
export const Tasks_RetriggerOrderFulfillment = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/tasks/trigger/order-fulfillment'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['req'] !== undefined) {
    body = parameters['req']
  }
  if (parameters['req'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: req'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('post', domain + path, body, queryParameters, form, config)
}
export const Tasks_RetriggerOrderFulfillment_RAW_URL = function() {
  return '/api/management/tasks/trigger/order-fulfillment'
}
export const Tasks_RetriggerOrderFulfillment_TYPE = function() {
  return 'post'
}
export const Tasks_RetriggerOrderFulfillmentURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/tasks/trigger/order-fulfillment'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: User_ListUsers
 * url: User_ListUsersURL
 * method: User_ListUsers_TYPE
 * raw_url: User_ListUsers_RAW_URL
 */
export const User_ListUsers = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/user'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const User_ListUsers_RAW_URL = function() {
  return '/api/management/user'
}
export const User_ListUsers_TYPE = function() {
  return 'get'
}
export const User_ListUsersURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/user'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: User_PromoteToSupervisor
 * url: User_PromoteToSupervisorURL
 * method: User_PromoteToSupervisor_TYPE
 * raw_url: User_PromoteToSupervisor_RAW_URL
 * @param cmd - 
 */
export const User_PromoteToSupervisor = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/user/promote'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const User_PromoteToSupervisor_RAW_URL = function() {
  return '/api/management/user/promote'
}
export const User_PromoteToSupervisor_TYPE = function() {
  return 'put'
}
export const User_PromoteToSupervisorURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/user/promote'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: User_DemoteToUser
 * url: User_DemoteToUserURL
 * method: User_DemoteToUser_TYPE
 * raw_url: User_DemoteToUser_RAW_URL
 * @param cmd - 
 */
export const User_DemoteToUser = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/user/demote'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const User_DemoteToUser_RAW_URL = function() {
  return '/api/management/user/demote'
}
export const User_DemoteToUser_TYPE = function() {
  return 'put'
}
export const User_DemoteToUserURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/user/demote'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: User_UpdateUserStatisticsPermission
 * url: User_UpdateUserStatisticsPermissionURL
 * method: User_UpdateUserStatisticsPermission_TYPE
 * raw_url: User_UpdateUserStatisticsPermission_RAW_URL
 * @param cmd - 
 */
export const User_UpdateUserStatisticsPermission = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/user/statistics-permission'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const User_UpdateUserStatisticsPermission_RAW_URL = function() {
  return '/api/management/user/statistics-permission'
}
export const User_UpdateUserStatisticsPermission_TYPE = function() {
  return 'put'
}
export const User_UpdateUserStatisticsPermissionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/user/statistics-permission'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: User_UpdateUserEditorPermission
 * url: User_UpdateUserEditorPermissionURL
 * method: User_UpdateUserEditorPermission_TYPE
 * raw_url: User_UpdateUserEditorPermission_RAW_URL
 * @param cmd - 
 */
export const User_UpdateUserEditorPermission = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/user/editor-permission'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['cmd'] !== undefined) {
    body = parameters['cmd']
  }
  if (parameters['cmd'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: cmd'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const User_UpdateUserEditorPermission_RAW_URL = function() {
  return '/api/management/user/editor-permission'
}
export const User_UpdateUserEditorPermission_TYPE = function() {
  return 'put'
}
export const User_UpdateUserEditorPermissionURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/user/editor-permission'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: User_ChangePassword
 * url: User_ChangePasswordURL
 * method: User_ChangePassword_TYPE
 * raw_url: User_ChangePassword_RAW_URL
 * @param req - 
 */
export const User_ChangePassword = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/user/change-password'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['req'] !== undefined) {
    body = parameters['req']
  }
  if (parameters['req'] === undefined) {
    return Promise.reject(new Error('Missing required  parameter: req'))
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('put', domain + path, body, queryParameters, form, config)
}
export const User_ChangePassword_RAW_URL = function() {
  return '/api/management/user/change-password'
}
export const User_ChangePassword_TYPE = function() {
  return 'put'
}
export const User_ChangePasswordURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/api/management/user/change-password'
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}